import type { SettingsRecord } from "./types";

/**
 * The provider woodpecker@0a1b and its services (D43). The constant is the fallback: the Console reads the provider
 * from its config.json (`provider`) and passes it to `providerServices` and `defaultSettings`.
 */
export const PROVIDER = "woodpecker@0a1b";
export const RUNNER_SERVICE = `${PROVIDER}/runner`;
export const MEMORY_SERVICE = `${PROVIDER}/memory`;
export const LLM_SERVICE = `${PROVIDER}/llm`;
export const HOST_SERVICE = `${PROVIDER}/cf`;
export const DEFAULT_MODEL = "gpt-6-luna";

/** The four services of a provider, by its handle (`owner@addr4`). */
export function providerServices(provider: string = PROVIDER) {
  return {
    runner: `${provider}/runner`,
    memory: `${provider}/memory`,
    llm: `${provider}/llm`,
    host: `${provider}/cf`,
  };
}

/** The starter pack of a new wallet (D44). */
export const STARTER_PACK: Record<string, number> = { tRunner: 50, tLLM: 50, tMemory: 50, tCloud: 20 };

/** The settings record of a wallet that never wrote one: the provider's defaults (D43, D50, D63). */
export function defaultSettings(provider: string = PROVIDER): SettingsRecord {
  const s = providerServices(provider);
  return {
    myServices: [s.runner, s.memory, s.llm, s.host],
    defaultCaps: {},
    defaultModel: `${s.llm}|${DEFAULT_MODEL}`,
    defaultEffort: "medium",
    defaultRunner: s.runner,
    defaultMemory: s.memory,
  };
}

/** The 17 steps of a deployment's progress rail (deploy.html; the mock's T_). */
export const DEPLOY_STEPS = [
  "details",
  "inspect",
  "plan",
  "validate",
  "check-key",
  "deploy-worker",
  "submitter",
  "set-key",
  "postcheck",
  "fund-submitter",
  "deploy-token",
  "set-service",
  "mint-allowance",
  "register",
  "bind",
  "verify",
  "done",
] as const;
export type DeployStep = (typeof DEPLOY_STEPS)[number];
export type StepState = "pending" | "running" | "done" | "needs signature" | "failed";
